exports.default = {
  'build_ideas_with_ai': '用AI團隊構建您的想法',
  'enter_your_question': '輸入你的問題...',
  'upload_image': '上傳圖片',
  'invalid_image_format': '圖片格式必須是 PNG、JPEG、JPG 或 WebP',
  'image_size_limit': '圖片大小不能超過 20MB',
  'custom_agents': '自定義智能體',
  'all_agents': '全部智能體',
  'agent_tools_nav_label': '智能體功能入口',
  'content_creation': '內容創作',
  'all_agents_tip_1': '查看全部智能體與官方推薦',
  'all_agents_tip_2': '按場景篩選並進入對應智能體',
  'custom_agents_tip_1': '建立或管理自定義智能體',
  'custom_agents_tip_2': '沉澱你的專屬工作流和團隊能力',
  'ai_slides': 'AI 幻燈片',
  'ai_slides_prompt': '幫我生成一份簡報，主題是：',
  'ai_sheets': 'AI 表格',
  'ai_sheets_prompt': '幫我整理一張表格，內容是：',
  'ai_docs': 'AI 文件',
  'ai_docs_prompt': '幫我寫一份文件，主題是：',
  'ai_designer': 'AI 設計師',
  'ai_designer_prompt': '幫我設計一個方案，需求是：',
  'ai_chat': 'AI 聊天',
  'ai_chat_prompt': '我想諮詢：',
  'ai_image': 'AI 圖片',
  'ai_image_prompt': '幫我生成一張圖片，畫面是：',
  'ai_music': 'AI 音樂',
  'ai_music_prompt': '幫我生成一段音樂創意，風格是：',
  'ai_video': 'AI 影片',
  'ai_video_prompt': '幫我生成一段影片腳本，主題是：',
  'ai_meeting': 'AI 紀要',
  'ai_meeting_prompt': '幫我整理會議紀要，內容是：',
  'unlimited_badge': '無限制',
  'text_agent_selector': '文本智能體膠囊選擇',
  'text_agent_default_desc': '選擇用於輔助理解需求的文本智能體',
  'no_text_agents': '暫無可用文本智能體',
  'web_entry_agent_missing': '暫無可用 AI 網頁智能體入口',
  'agent_coming_soon': '敬請期待',
  'featured_cases': '精選案例',
  'recents': '最近',
  'view_all': '查看全部',
  'no_recents': '暫無最近案例',
  'more': '載入更多',
  'new_web_case': '新建網頁案例',
  'featured_templates': '精選模板',
  'default': '默認',
  'latest': '最新',
  'popular': '熱門',
  'all': '所有',
  'preview': '預覽',
  'no_more_data': '沒有更多數據了',
  'max_upload_images': '最多同時上傳{count}張圖片',
  'remixes': 'Remixes',
  'file_size_limit': '上傳圖片大小不能超過20M',
  'paste_content_too_long': '粘貼內容過長，已截取前{count}個字符',
  'content_too_long': '內容過長，已截取前{count}個字符',
  'short_text_insert_failed': '短文本插入失敗',
  'chunk_insert_failed': '分片插入失敗',
  'file_read_failed': '文件讀取失敗',
  'image_compress_failed': '圖片壓縮失敗',
  'use_template': '使用模板',
  'use_template_desc': '使用此模板，您將創建一個屬於您的副本。',
  'mode_title': '模式',
  'mode_desc': '設定 AI 模式。更快的模式消耗更少積分，更智能的模式效果更好。',
  'mode_recommended': '推薦',
  'mode_lite': 'Lite',
  'mode_lite_desc': '經濟型選項，相同任務消耗更少積分。',
  'mode_standard': 'Standard',
  'mode_standard_desc': '適用於大多數任務。',
  'mode_ultra': 'Ultra',
  'mode_ultra_desc': '使用平台設定的最強模型，適合複雜推理和長任務。Ultra 模式將消耗更多積分。',
  'model_selector': '選擇 Pai 模型',
  'selected_text_model': '所選文字模型',
  'model_reasoning': '推理',
  'model_image': '圖片',
  'no_image_models': '暫無可用圖片模型',
  'model_not_support_image': '目前模型不支援參考圖，請更換模型或移除圖片後再發送',
  'image_model_reference_limit': '目前圖片模型最多支援 {count} 張參考圖，請處理後再發送'
}
